import { h, Component} from 'preact';
import cn from 'classnames';
import Icon from '../icon/icon';
import styles from './loader.css';

export default class extends Component {
  render() {
    const { className } = this.props;

    return <Icon glyph="loader" className={cn(styles.loader, className)} />;
  }
}



// WEBPACK FOOTER //
// ./components/loader/loader.jsx